import { Link } from "react-router-dom";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  moreHref?: string;
  moreLabel?: string;
}

export default function SectionHeader({
  title,
  subtitle,
  moreHref,
  moreLabel = "查看全部",
}: SectionHeaderProps) {
  return (
    <div className="mb-4 flex flex-wrap items-end justify-between gap-3 md:mb-5">
      <div className="flex items-center gap-3">
        <span className="h-6 w-1 rounded-full bg-accent-500 md:h-7" aria-hidden="true" />
        <div>
          <h2 className="font-heading text-lg font-bold tracking-tight text-foreground-950 md:text-xl">
            {title}
          </h2>
          {subtitle ? <p className="mt-0.5 text-xs text-foreground-500 md:text-sm">{subtitle}</p> : null}
        </div>
      </div>
      {moreHref ? (
        <Link
          to={moreHref}
          className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-base" aria-hidden="true" />
        </Link>
      ) : null}
    </div>
  );
}